import { admin_storeAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import dayjs from 'dayjs';
import store from '@/store';
import { asFormData } from '@/common/utils/ServiceSupport';

export default {
  async fetchAdminStores({ commit, getters, dispatch }, payload) {
    const { data, status } = await ServiceExec.get(
      admin_storeAPI.my_shop,
      payload
    );

    const today = dayjs().format('YYYY-MM-DD');
    if (status === 200) {
      for (const item of data.list) {
        const payload = {
          storeNo: item.storeNo,
          date: today
          // periodCondition: 'DASHBOARD_DAY'
        };
        // // 매출 금액 그래프
        // item.dashboard_sales = await store.dispatch(
        //   'admin_store/fetchDashBoardSales',
        //   payload
        // );
        // // 주문 수 그래프
        // item.dashboard_count = await store.dispatch(
        //   'admin_store/fetchDashBoardCount',
        //   payload
        // );
        // // 거래 이벤트 그래프
        // item.dashboard_event = await store.dispatch(
        //   'admin_store/fetchDashBoardTransaction',
        //   payload
        // );
        // 거래 이벤트(분류)
        item.eventCount = await dispatch('FETCH_DASH_BOARD_EVENT', {
          storeNo: payload.storeNo
        });
        const favResponse = await dispatch('FETCH_FAV_COUNT', payload);
        if (favResponse) {
          const { product, store } = favResponse;
          item.favStoreCount = store ?? 0;
          item.favProductCount = product ?? 0;
        }
      }
    }
    commit('setAdminStoreList', data);
  },

  async fetchRecommendedStoreList({ commit }, payload) {
    const customParam = { ...payload, isRecommended: true };
    const { status, data } = await ServiceExec.get(
      admin_storeAPI.storeList,
      customParam
    );
    const { pageInfo, list } = data;
    commit('setRecommendedStoreList', list ?? []);
    return data;
  },

  async updateWorkState({ commit }, payload) {
    payload.isWork = !payload.isWork;
    const { data } = await ServiceExec.put(
      admin_storeAPI.update_business,
      payload
    );
  },

  async updateDeliveryState({ commit }, payload) {
    payload.isDeliverable = !payload.isDeliverable;
    const { data } = await ServiceExec.put(
      admin_storeAPI.update_business,
      payload
    );
  },

  async getStoreDetail({ commit }, storeNo) {
    const { data } = await ServiceExec.get(
      admin_storeAPI.my_shop_detail(storeNo)
    );
    commit('setAdminStoreInfo', data);
    return data;
  },

  async basicSave({ commit }, payload) {
    if (payload.files) delete payload.files;
    const imageResponse = await ServiceExec.post(
      admin_storeAPI.image_save,
      asFormData(payload)
    );

    if (payload.firstRawFile) delete payload.firstRawFile;
    if (payload.secondRawFile) delete payload.secondRawFile;
    if (payload.thirdRawFile) delete payload.thirdRawFile;
    if (payload.forthRawFile) delete payload.forthRawFile;
    if (payload.fifthRawFile) delete payload.fifthRawFile;
    const baseResponse = await ServiceExec.post(
      admin_storeAPI.basic_save,
      payload
    );
    if (baseResponse.status === 200 && imageResponse.status === 200)
      return true;
    return false;
  },

  async businessSave({ commit }, payload) {
    payload.businessDaysModified = payload.businessDaysModified === true;
    payload.breakTimesModified = payload.breakTimesModified === true;
    payload.holidaysModified = payload.holidaysModified === true;

    const { data, status } = await ServiceExec.put(
      admin_storeAPI.business_save,
      payload
    );

    if (status === 200)
      await store.dispatch('admin_store/getStoreDetail', payload.storeNo);

    return status === 200;
  },

  async paymentSave({ commit }, payload) {
    const { data, status } = await ServiceExec.put(
      admin_storeAPI.payment_save,
      payload
    );

    if (status === 200)
      await store.dispatch('admin_store/getStoreDetail', payload.storeNo);

    return status === 200;
  },

  async deliverySave({ commit }, payload) {
    const { data, status } = await ServiceExec.put(
      admin_storeAPI.delivery_save,
      payload
    );

    if (status === 200)
      await store.dispatch('admin_store/getStoreDetail', payload.storeNo);

    return status === 200;
  },

  async FETCH_DASH_BOARD_COUNT({ commit }, payload) {
    const { status, data } = await ServiceExec.get(
      admin_storeAPI.dashboard_count,
      payload
    );
    if (status === ServiceExec.status.OK) commit('setCount', data);
  },

  async FETCH_DASH_BOARD_SALES({ commit }, payload) {
    const { status, data } = await ServiceExec.get(
      admin_storeAPI.dashboard_sales,
      payload
    );
    if (status === ServiceExec.status.OK) commit('setSales', data);
  },

  async FETCH_DASH_BOARD_TRANSACTION({ commit }, payload) {
    const { status, data } = await ServiceExec.get(
      admin_storeAPI.dashboard_transaction,
      payload
    );
    if (status === ServiceExec.status.OK) commit('setTransaction', data);
  },

  async FETCH_DASH_BOARD_EVENT({ commit }, payload) {
    const { data } = await ServiceExec.get(
      admin_storeAPI.dashboard_classify,
      payload
    );
    return data;
  },
  async FETCH_FAV_COUNT({ commit }, { storeNo }) {
    const { data } = await ServiceExec.get(
      admin_storeAPI.dashboard_fav(storeNo)
    );

    return data;
  }
};
